import React from "react";

import { faSlidersH } from "@fortawesome/free-solid-svg-icons";

import "./styles/skills.css";
import Card from "../common/card";

const Skills = (props) => {
	// const { title, description, date, link } = props;

	return (
		<div className="skills">
			<Card
				icon={faSlidersH}
				title="Skill"
				body={
					<div className="skill-body" align="center">
						<div className="skill">
							<div className="skill-title" style={{marginBottom: '5px'}}>Languages & Databases</div>
							<img 
							src="https://go-skill-icons.vercel.app/api/icons?i=javascript,php,mysql,java,typescript,python" 
							alt="" />
						</div>

						<div className="skill">
							<div className="skill-title" style={{marginBottom: '5px'}}>Frameworks & Technologies</div>
							<img 
							src="https://go-skill-icons.vercel.app/api/icons?i=laravel,vite,react,codeigniter,nodejs,android,vue"
							alt="" />
						</div>

					</div>
				}
			/>
		</div>
	);
};

export default Skills;
